@if (course) {
	<app-field-label>Section Editor</app-field-label>
	@if (editSection) {
		<app-section-form
			[course]="course"
			(onSave)="saveSection($event); table.reloadPage()"
			(onClear)="edit(undefined)"
			[editSection]="editSection"
		></app-section-form>
	}
	<app-section-table
		[course]="course"
		[clientUuid]="course.client_uuid"
		[editSection]="editSection"
		(onEditSection)="edit($event)"
		(onDelete)="delete($event)"
		#table
	></app-section-table>
	<br />
	<div class="save-buttons">
		<button nz-button (click)="addNewSection(); $event.preventDefault()">Add New Section</button>
	</div>
}
